import { useEffect, useRef, useState } from 'react'

export default function MemberSearchDropdown({ members, onSelect, onClose }) {
    const [search, setSearch] = useState('')
    const ref = useRef(null)
    const inputRef = useRef(null)

    useEffect(() => {
        inputRef.current?.focus()
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) onClose()
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [onClose])

    const filtered = members.filter(m => {
        const name = (m.full_name || m.email || '').toLowerCase()
        return name.includes(search.toLowerCase())
    })

    return (
        <div className="member-search-dropdown" ref={ref}>
            <input
                ref={inputRef}
                className="inline-input"
                placeholder="Cauta membru..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                onKeyDown={e => e.key === 'Escape' && onClose()}
            />
            <div className="member-search-list">
                {filtered.map(m => (
                    <button
                        key={m.id}
                        type="button"
                        className="member-search-item"
                        onMouseDown={(e) => { e.preventDefault(); onSelect(m.id) }}
                    >
                        {m.full_name || m.email || 'Utilizator'}
                    </button>
                ))}
                {filtered.length === 0 && <div className="member-search-empty">Niciun rezultat</div>}
            </div>
            <button className="btn btn-secondary btn-sm cd-cancel-inline" onClick={onClose}>Anuleaza</button>
        </div>
    )
}
